var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8992 4.13629C17.9113 4.31129 17.9113 4.48629 17.9113 4.66291C17.9113 10.0444 13.8145 16.2508 6.3234 16.2508V16.2476C4.1105 16.2508 1.94356 15.6169 0.080658 14.4218C0.402432 14.4605 0.725819 14.4798 1.05001 14.4806C2.88388 14.4823 4.66534 13.8669 6.10808 12.7339C4.36534 12.7008 2.83711 11.5645 2.30324 9.90565C2.91372 10.0234 3.54276 9.9992 4.14195 9.83549C2.24195 9.45162 0.875013 7.78226 0.875013 5.84355C0.875013 5.82581 0.875013 5.80887 0.875013 5.79194C1.44114 6.10726 2.07501 6.28226 2.7234 6.30162C0.933884 5.10565 0.382271 2.725 1.46292 0.863712C3.53066 3.40807 6.58146 4.95484 9.85647 5.11855C9.52824 3.70403 9.97663 2.22178 11.0347 1.22742C12.675 -0.314514 15.2549 -0.235482 16.7968 1.40403C17.7089 1.2242 18.5831 0.889518 19.3831 0.415325C19.079 1.35807 18.4428 2.15887 17.5928 2.66774C18.4 2.57258 19.1887 2.35645 19.9315 2.02661C19.3847 2.84597 18.696 3.55968 17.8992 4.13629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.90ae9f334e4e11e459615daf07877b09.svg";
export { ForwardRef as ReactComponent };